import { useQuery } from '@tanstack/react-query'

import { ChainId } from '@src/configs/chainInfo'
import { getTronEnergyPrice } from '@src/utils/tron/utils'

export const getTronGasFeeMetrics = async (gasFeeBufferBips: bigint = BigInt(11000)) => {
    const tronFees = await getTronEnergyPrice()
    if (tronFees.energyPrice && tronFees.bandwidthPrice) {
        return {
            chainId: ChainId.Tron,
            currentGasPrice: BigInt(0),
            isEIP1559: false,
            isTron: true,
            TronParams: {
                energyPrice: (BigInt(tronFees.energyPrice) * gasFeeBufferBips) / BigInt(10000),
                bandwidthPrice: BigInt(tronFees.bandwidthPrice), // Is negligible compared to energy fee
            },
            isSolana: false,
        }
    } else {
        throw new Error(`Tron energy price is undefined.`)
    }
}

export const useGasFeeMetricsTron = (chainId: number, gasFeeBufferBips: bigint) => {
    const isTronChain = chainId === ChainId.Tron

    const {
        data: gasFeeMetrics,
        error,
        isLoading,
    } = useQuery({
        queryKey: ['tronGasFeeMetrics', chainId],
        queryFn: () => getTronGasFeeMetrics(gasFeeBufferBips),
        staleTime: 60000, // 1 minute caching
        enabled: isTronChain,
        retry: 2,
    })

    return {
        gasFeeMetrics: gasFeeMetrics || null,
        error: error ? `Error fetching Tron gas metrics: ${(error as Error).message}` : null,
        isLoading: isTronChain && isLoading,
    }
}
